import { render } from "./popup-setor-harian-kurir-v2.vue?vue&type=template&id=60265a92&scoped=true&ts=true"
import script from "./popup-setor-harian-kurir-v2.vue?vue&type=script&lang=ts"
export * from "./popup-setor-harian-kurir-v2.vue?vue&type=script&lang=ts"

import "./popup-setor-harian-kurir-v2.vue?vue&type=style&index=0&id=60265a92&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60265a92"]])

export default __exports__